import { customStyle, pxToRem, mediaQueries } from 'styles/functions'

const Theme = {
  card_background_color: '#010306',

  header_hidden: true,
  number_hidden: true,

  body_background_color: '#010306',

  button_color: '#00ffff',

  text_font: `'Agency FB', serif`,
  text_color: '#00ffff',
  title_font: `'Agency FB', serif`,
  title_color: '#00ffff',

  footer_text_color: '#00ffff',
  footer_font: 'Open Sans, sans-serif',

  custom_button: customStyle(`
  background-color: #001254;
  padding: 0;
  border: none;
  border-bottom: ${pxToRem(3)} solid #00ffff;
  border-radius: ${pxToRem(50)} ${pxToRem(50)} ${pxToRem(92)} ${pxToRem(92)};

  label {
    position: relative;
    font-size: ${pxToRem(22)};
    border-top: ${pxToRem(3)} solid #00ffff;
    padding: ${pxToRem(20)} 0;
    max-width: 80%;
    margin: auto;

    &:before,
    &:after {
      content: '';
      border-top: ${pxToRem(5)} solid #00ffff;
      border-bottom: ${pxToRem(5)} solid #00ffff;
      height: calc(100% + ${pxToRem(8)});
      position: absolute;
      width: ${pxToRem(20)};
      left: calc(50% - ${pxToRem(10)});
      top: ${pxToRem(-4)}
    }

    &:before {
      margin-left: -${pxToRem(20)};
    }
    
    &:after {
      margin-left: ${pxToRem(20)};
    }
  }
`),

  custom_paragraph_missionbiorobotique: customStyle(`
    position: relative;
    border: ${pxToRem(5)} solid #00ffff;
    padding: ${pxToRem(50)} ${pxToRem(20)} ${pxToRem(40)} ${pxToRem(20)};
    background-color: #004143;
    border-radius: ${pxToRem(2)};
    font-size: ${pxToRem(18)};

    &:before,
    &:after {
      position: absolute;
      width: 100%;
      height: 100%;
      content: '';
      top: -${pxToRem(5)};
      left: -${pxToRem(5)};
      background: url('/static/images/missionbiorobotique/top-left.png') left top no-repeat;
      background-size: ${pxToRem(193)} ${pxToRem(21)};
    }

    &:after {
      background: url('/static/images/missionbiorobotique/botton-right.png') right bottom no-repeat;
      background-size: ${pxToRem(140)} ${pxToRem(22)};
      margin-top: ${pxToRem(10)};
      margin-left: ${pxToRem(10)};
      
      ${mediaQueries('phone')(`
        display: none;
      `)}
    }
  `),

  custom_token: customStyle(`
    background-color: #010306;
    background-size: contain;
    border-radius: 50%;
    width: ${pxToRem(60)};
    height: ${pxToRem(60)};
    margin: ${pxToRem(5)} 0 0;
    z-index: 2;

    &:before {
      position: absolute;
      top: 0;
      left: 0;
      width: ${pxToRem(69)};
      height: ${pxToRem(69)};
      content: '';
      background: url('/static/images/missionbiorobotique/circle.svg') center center no-repeat;
      border-radius: 50%;
      margin: -${pxToRem(5)} 0 0 -${pxToRem(5)};
    }

    img {
      display: none;
    }
  `),

  custom_title_missionbiorobotique: customStyle(`
    position: absolute;
    left: ${pxToRem(50)};
    background-color: #004143;
    padding: ${pxToRem(5)} ${pxToRem(20)} ${pxToRem(5)} ${pxToRem(30)};
    border-radius: ${pxToRem(6)};
    border: ${pxToRem(1)} solid #00ffff;
    margin: ${pxToRem(10)} -${pxToRem(5)} ${pxToRem(14)} 0;
    width: calc(100% - 50px);

    &:before,
    &:after {
      content: '';
      background: #000;
      border: ${pxToRem(1)} solid #00ffff;
      position: absolute;
      width: ${pxToRem(20)};
      height: ${pxToRem(20)};
      right: -${pxToRem(9)};
      z-index: -1;
    }

    &:before {
      top: -${pxToRem(7)};
      border-radius: 0 ${pxToRem(6)} 0 0;
    }

    &:after {
      bottom: -${pxToRem(7)};
      border-radius: 0 0 ${pxToRem(6)} 0;
    }
  `),
}

export default Theme
